import { render } from "./LowerThirdScroll.vue?vue&type=template&id=feaa3c2a"
import script from "./LowerThirdScroll.vue?vue&type=script&lang=js"
export * from "./LowerThirdScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__